module.exports = __webpack_public_path__ + "img/rights@2x.ec97993.webp";